<div class="lead-loading">
  <header class="w-100"></header>

  <div class="pt-6 d-flex flex-column g-8 lead-loading-body desktop">
    <div class="d-flex flex-column g-4">
      <ds-skeleton class="radius-small" [width]="220" [height]="34" />

      <div class="d-flex flex-column g-2">
        <ds-skeleton class="radius-small" [width]="720" [height]="16" />
        <div class="d-flex g-5">
          <ds-skeleton class="radius-small" [width]="220" [height]="16" />
          <ds-skeleton class="radius-small" [width]="100" [height]="16" />
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="leadDesktop" />

    <ng-container *ngTemplateOutlet="leadDesktop" />

    <need-help-card />

    <footer></footer>
  </div>

  <div class="d-flex d-md-none flex-column lead-loading-body">
    <div class="d-flex flex-column gap-medium lead-loading-body-header gap-medium pr-4 pl-4 pb-3">
      <div class="d-flex align-items-center g-4">
        <ds-skeleton class="radius-small" [width]="130" [height]="16" />
        <ds-skeleton class="radius-small" [width]="106" [height]="16" />
      </div>
    </div>

    <div class="d-flex flex-column g-3 lead-loading-body-cards p-3">
      <ng-container *ngTemplateOutlet="leadMobile" />

      <ng-container *ngTemplateOutlet="leadMobile" />
      <need-help-card />
    </div>

    <footer class="pr-4 pl-4"></footer>
  </div>
</div>

<ng-template #leadDesktop>
  <div class="d-flex flex-column g-4">
    <div class="d-flex flex-column gap-medium">
      <ds-skeleton class="radius-small" [width]="160" [height]="32" />
      <ds-skeleton class="radius-small" [width]="700" [height]="16" />
    </div>

    <div class="d-flex g-6 card w-100">
      <div class="d-flex flex-column p-6 g-6 card-left">
        <ds-skeleton class="round" [width]="44" [height]="44" />

        <div class="d-flex flex-column g-4">
          <div class="d-flex flex-column gap-medium">
            <div class="d-flex g-5 align-items-center">
              <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
              <ds-skeleton class="w-100" [height]="1" />
              <ds-skeleton class="radius-small" [minWidth]="120" [width]="120" [height]="22" />
              <ds-skeleton class="w-100" [height]="1" />
              <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
            </div>

            <div class="d-flex justify-content-between align-items-center w-100">
              <ds-skeleton class="radius-small" [width]="100" [height]="16" />
              <ds-skeleton class="radius-small" [width]="100" [height]="16" />
            </div>
          </div>

          <div class="d-flex flex-column gap-medium">
            <div class="d-flex g-5 align-items-center">
              <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
              <ds-skeleton class="w-100" [height]="1" />
              <ds-skeleton class="radius-small" [minWidth]="120" [width]="120" [height]="22" />
              <ds-skeleton class="w-100" [height]="1" />
              <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
            </div>

            <div class="d-flex justify-content-between align-items-center w-100">
              <ds-skeleton class="radius-small" [width]="100" [height]="16" />
              <ds-skeleton class="radius-small" [width]="100" [height]="16" />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column align-items-center justify-content-between card-right p-6">
        <div
          class="d-flex flex-column card-right-wrapper align-items-center justify-content-center w-100 gap-medium"
        >
          <ds-skeleton class="radius-small" [width]="120" [height]="22" />
          <ds-skeleton class="radius-small" [width]="100" [height]="16" />
        </div>
        <ds-skeleton class="radius-small" [width]="220" [height]="44" />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #leadMobile>
  <div class="lead-loading-body-cards-item">
    <div class="lead-loading-body-cards-item-header">
      <div class="p-4">
        <ds-skeleton class="radius-small" [width]="120" [height]="24" />
      </div>
    </div>

    <div class="d-flex flex-column p-4 g-4">
      <ds-skeleton class="round" [width]="32" [height]="32" />

      <div class="d-flex flex-column g-4">
        <div class="d-flex flex-column gap-medium">
          <div class="d-flex g-5 align-items-center">
            <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
            <ds-skeleton class="w-100" [height]="1" />
            <ds-skeleton class="radius-small" [minWidth]="90" [width]="90" [height]="22" />
            <ds-skeleton class="w-100" [height]="1" />
            <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
          </div>

          <div class="d-flex justify-content-between align-items-center w-100">
            <ds-skeleton class="radius-small" [width]="100" [height]="16" />
            <ds-skeleton class="radius-small" [width]="100" [height]="16" />
          </div>
        </div>

        <div class="d-flex flex-column gap-medium">
          <div class="d-flex g-5 align-items-center">
            <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
            <ds-skeleton class="w-100" [height]="1" />
            <ds-skeleton class="radius-small" [minWidth]="90" [width]="90" [height]="22" />
            <ds-skeleton class="w-100" [height]="1" />
            <ds-skeleton class="radius-small" [minWidth]="40" [width]="40" [height]="22" />
          </div>

          <div class="d-flex justify-content-between align-items-center w-100">
            <ds-skeleton class="radius-small" [width]="100" [height]="16" />
            <ds-skeleton class="radius-small" [width]="100" [height]="16" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="lead-loading-body-cards-item-footer d-flex p-4 align-items-center justify-content-between"
    >
      <div class="d-flex g-1 flex-column">
        <ds-skeleton class="radius-small" [width]="40" [height]="22" />
        <ds-skeleton class="radius-small" [width]="100" [height]="16" />
      </div>

      <ds-skeleton class="radius-small" [width]="100" [height]="32" />
    </div>
  </div>
</ng-template>
